<div class="privacy-container">
  <h1>Privacy Policy – ReBall</h1>

  <h2>1. Introduction</h2>
  <p>
    Welcome to ReBall.<br />
    This Privacy Policy explains how we collect, use, and protect your personal
    data when you use our mobile application.<br />
    By using the ReBall app, you confirm that you have read, understood, and
    agreed to this Privacy Policy.
  </p>

  <hr />

  <h2>2. Data Controller</h2>
  <p>The controller responsible for the processing of personal data is:</p>
  <p>
    DIMITRIJE KRSTOVIĆ ENTREPRENEUR COMPUTER PROGRAMMING<br />
    REBALL BELGRADE (VOŽDOVAC)<br />
    Republic of Serbia, Belgrade<br />
    office&#64;reball.rs
  </p>

  <hr />

  <h2>3. Data We Collect</h2>
  <p>We only collect the data you provide when using the app, including:</p>
  <ul>
    <li>First and last name</li>
    <li>Email address</li>
    <li>Username</li>
    <li>Password</li>
  </ul>
  <p>Additionally, the following information may be stored within the app:</p>
  <ul>
    <li>
      Game statistics (number of matches played, wins, losses, progress over
      time)
    </li>
    <li>Profile settings (e.g. availability status)</li>
  </ul>

  <hr />

  <h2>4. How We Use Your Data</h2>
  <p>We use your personal data solely for the following purposes:</p>
  <ul>
    <li>To create and maintain your user account</li>
    <li>To enable players to connect and organize matches</li>
    <li>To display your profile and match statistics to other users</li>
    <li>To improve the functionality and user experience of the app</li>
    <li>To maintain security and prevent misuse</li>
  </ul>
  <p>
    We do not use your data for marketing or advertising purposes, nor do we
    perform any automated profiling.
  </p>

  <hr />

  <h2>5. Location and Payments</h2>
  <p>
    The ReBall app does not use GPS and does not track users' locations.<br />
    The app is completely free to use and does not process any payment or credit
    card data.
  </p>

  <hr />

  <h2>6. Data Sharing</h2>
  <p>
    Your personal data is not shared with third parties and remains within the
    ReBall system.
  </p>
  <p>The only information visible to other users includes:</p>
  <ul>
    <li>Your name and username</li>
    <li>
      Your match statistics (wins, losses, matches played, performance progress)
    </li>
  </ul>
  <p>
    If you do not wish to be invited to matches, you can set your status to
    "busy", which hides your availability from other users.
  </p>

  <hr />

  <h2>7. Data Security and Retention</h2>
  <p>
    Your data is stored on secure servers with appropriate technical and
    organizational safeguards in place.<br />
    Passwords are encrypted and never visible to administrators.
  </p>
  <p>
    Data is retained as long as your account remains active.<br />
    If you delete your account, all personal data will be permanently erased
    within a reasonable timeframe.
  </p>

  <hr />

  <h2>8. Your Rights</h2>
  <p>You have the right to:</p>
  <ul>
    <li>Access your personal data</li>
    <li>Correct inaccurate information</li>
    <li>Request account and data deletion ("right to be forgotten")</li>
    <li>Restrict or object to data processing</li>
  </ul>
  <p>
    To exercise these rights, please contact us at office&#64;reball.rs.<br />
    We will respond within 30 days.
  </p>

  <hr />

  <h2>9. Analytics and Cookies</h2>
  <p>
    ReBall does not use Google Analytics, Firebase, Meta SDK, or any other
    tracking or marketing tools.<br />
    The application does not use cookies.
  </p>

  <hr />

  <h2>10. App Store and Google Play Compliance</h2>
  <p>
    This Privacy Policy complies with the Google Play and Apple App Store data
    safety requirements.<br />
    The policy is available to users both inside the app and on our website.
  </p>

  <hr />

  <h2>11. Changes to This Policy</h2>
  <p>
    We may update this Privacy Policy from time to time.<br />
    Any changes will be published within the app and on our website, with the
    effective date clearly indicated.
  </p>

  <hr />

  <h2>12. Contact</h2>
  <p>
    If you have any questions about this Privacy Policy or your data, please
    contact us:<br />
    office&#64;reball.rs<br />
    Belgrade, Republic of Serbia
  </p>
</div>
